import { AnyFunction } from '@vkontakte/vkjs';
import { callToMain } from '../eventLoop';

export class TaskQueue {
  private static readonly eventsQueue: AnyFunction[] = [];
  private static isExecuting = false;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  private static deferCall = window.requestIdleCallback?.bind(window) || callToMain;

  private static runQueue() {
    const task = this.eventsQueue.shift() as AnyFunction;
    this.isExecuting = true;
    this.deferCall(() => {
      try {
        task();
      } catch (e) {
        console.error('TaskQueue error', e);
      } finally {
        if (this.eventsQueue.length) {
          TaskQueue.runQueue();
        } else {
          this.isExecuting = false;
        }
      }
    });
  }

  static push(callback: AnyFunction) {
    this.eventsQueue.push(callback);
    if (!this.isExecuting) {
      this.runQueue();
    }
  }
}
